import { VStack } from '@chakra-ui/react'
import { SearchResults } from '../../../../search'
import { MobileMenuGroup } from './MobileMenuGroup'
import { MobileMenuSearchPanel } from './MobileMenuSearchPanel'
import { useMobileMenuContext } from './MobileMenuContext'

interface MobileMenuSearchScreenProps {
  onClose: () => void
}

export const MobileMenuSearchScreen = ({ onClose }: MobileMenuSearchScreenProps) => {
  const { search } = useMobileMenuContext()

  if (!search) {
    return null
  }

  const { data, onKeyDown, inputRef, searchQuery, isLoading } = search

  return (
    <VStack alignItems="stretch" className="mobile-menu-search" h="100%" w="100%">
      <MobileMenuGroup>
        <MobileMenuSearchPanel
          inputProps={{
            onKeyDown
          }}
          inputRef={inputRef}
          isLoading={isLoading}
          onClickClose={onClose}
        />
      </MobileMenuGroup>

      <MobileMenuGroup overflowX="hidden" overflowY="auto">
        <SearchResults
          items={data}
          maxLength={10}
          searchPagePath="/search"
          searchQuery={searchQuery}
          w="100%"
        />
      </MobileMenuGroup>
    </VStack>
  )
}
